export const mosstalkOverview = {
  heroTitle: 'MossTalk',
  heroSubtitle: '随身 AI 翻译官，140+ 语种全球畅聊',
  heroTag: 'AI 随身翻译硬件',
  heroDesc: 'MossTalk 是新译科技面向个人用户打造的随身AI翻译硬件产品线，涵盖指环翻译机（标准款/商务款）与降噪翻译耳机，覆盖出境商旅、跨境沟通、外语学习全场景。轻巧便携，APP基础功能永久免费，让世界语言沟通无界限。',
  heroImageQuery: 'MossTalk complete product lineup display, ring shaped AI translator devices in three colors black silver rose gold next to premium open ear translation earbuds with charging case, compact portable translation wearable gadgets, travel lifestyle scene with airport background, modern consumer electronics, clean product photography, warm natural lighting, premium aesthetic',
  heroImageSeq: 'mosstalk-overview-hero',
};

export const mosstalkProducts = [
  {
    id: 'standard',
    title: '标准款翻译机',
    subtitle: '指环式随身翻译官',
    desc: '指环支架式便携翻译硬件，60mAh电池、35g净重，蓝牙4.2连接手机APP，依托大模型实现全场景随身翻译。140+语种在线翻译，10种离线语种，充电30分钟待机30天。',
    features: ['140+语种', '10种离线', '35g超轻', '永久免费'],
    href: '/mosstalk/standard',
    imageQuery: 'MossTalk standard ring shaped AI translator device in three colors black silver rose gold arranged on clean white surface, compact 35g finger ring translator gadget with smartphone showing translation app, lightweight portable language translator, modern consumer electronics product photography, soft studio lighting, premium minimalist aesthetic',
    imageSeq: 'mosstalk-standard-card',
  },
  {
    id: 'business',
    title: '商务款翻译机',
    subtitle: '商务专属 AI 翻译',
    desc: '在标准款全功能基础上，新增AI会议总结、思维导图生成、跨语言群组聊天、大模型AI问答、耳机同传播报等专属商务功能。商务出差、跨境洽谈必备利器。',
    features: ['AI会议总结', '思维导图', '群组聊天', '耳机同传'],
    href: '/mosstalk/business',
    imageQuery: 'MossTalk business edition premium translator device in titanium grey finish on executive desk with laptop showing AI meeting summary and mind map visualization, professional business setting with documents, luxury ring shaped business translator gadget, clean product photography, warm executive lighting, blue and gold accents',
    imageSeq: 'mosstalk-business-card',
  },
  {
    id: 'earbuds',
    title: '翻译耳机',
    subtitle: '降噪翻译耳机',
    desc: '通话降噪翻译耳机，集降噪+通话+音乐+运动+翻译五大功能于一体。100dB主动降噪，140+语种毫秒翻译，开放式佩戴，40小时超长续航，商务通勤与运动出行全能搭档。',
    features: ['100dB降噪', '140+语种', '开放式佩戴', '40h续航'],
    href: '/mosstalk/earbuds',
    imageQuery: 'MossTalk wireless translation earbuds with open ear design and charging case, ANC noise cancelling translator earphones for cross language communication, five in one device combining noise cancelling calling music sports and translation, clean white background product photography, modern wearable tech, studio lighting, minimalist aesthetic',
    imageSeq: 'mosstalk-earbuds-card',
  },
];

export const mosstalkEcosystem = {
  title: '随身翻译全场景覆盖',
  subtitle: '标准款 + 商务款 + 翻译耳机，满足从日常出行到商务洽谈的全场景需求',
  desc: 'MossTalk 三大产品精准定位不同使用场景：标准款主打日常出行与语言学习，商务款聚焦跨境商务与会议场景，翻译耳机覆盖通勤通话与运动出行。APP基础功能永久免费，从小白到商务精英，总有一款适合你。',
  points: [
    { icon: 'ri-smartphone-line', title: '标准款', desc: '日常出行翻译利器，35g超轻指环设计，140+语种随身翻译，永久免费APP' },
    { icon: 'ri-briefcase-line', title: '商务款', desc: '商务会议专属，AI总结+思维导图+群组聊天，跨境洽谈专业助手' },
    { icon: 'ri-headphone-line', title: '翻译耳机', desc: '降噪通话翻译一体，100dB ANC，40小时续航，通勤运动全能搭档' },
  ],
};

export const standardData = {
  banner: {
    title: 'MossTalk Pro AI 大模型指环翻译机',
    subtitle: '您的随身翻译官',
    tag: '140+ 语种 · 35g 超轻 · 三色可选',
    imageQuery: 'MossTalk Pro ring shaped AI large language model translator device in three elegant colors black rose gold silver arranged beautifully on clean white surface, compact 35g finger ring portable translation hardware, smartphone showing translation app interface, modern consumer electronics product photography, soft premium studio lighting, minimalist aesthetic',
    imageSeq: 'standard-banner',
  },
  overview: {
    title: '产品概述',
    content: 'MossTalk Pro 是新译科技推出的 AI 大模型指环翻译机，采用创新的指环支架式便携设计，净重仅 35g，搭配 60mAh 电池通过蓝牙 4.2 连接手机 APP，即可解锁全场景翻译功能。依托大模型引擎实现文本翻译、语音翻译、拍照翻译、实时对话翻译、基础同传、音视频通话双语字幕等多种功能，支持 140+ 语种在线翻译及 10 种离线语种。充电 30 分钟即可待机 30 天，APP 基础功能永久免费。三色可选（曜石黑、玫瑰金、星耀银），轻松搭配个人风格。',
    imageQuery: 'Person wearing MossTalk Pro ring translator device on finger using smartphone translation app in modern cafe, real time Chinese English dialogue translation interface visible on phone screen, compact 35g travel language gadget, lifestyle product photography, natural warm cafe lighting, clean minimal photography, daily communication scene',
    imageSeq: 'standard-overview',
  },
  scenarios: {
    title: '适用场景',
    items: [
      {
        icon: 'ri-flight-takeoff-line', name: '出境旅游', desc: '餐厅点餐、酒店入住、景点问路、购物砍价，140+语种实时翻译无障碍',
        imageQuery: 'Chinese traveler using MossTalk ring translator device to communicate at foreign restaurant, ordering food with real time language translation on smartphone, travel lifestyle scene in overseas dining setting, 140 plus language support visible on app, warm outdoor cafe lighting, cultural exploration photography, clean aesthetic',
        imageSeq: 'st-scenario-1',
        imageSrc: '/images/mosstalk/standard/9-travel.jpg',
      },
      {
        icon: 'ri-chat-3-line', name: '日常外语交流', desc: '与外国朋友聊天、参加语言交换活动，对话翻译自然流畅',
        imageQuery: 'Two friends from different cultures having casual conversation using MossTalk ring translator for real time dialogue translation, one wearing finger ring device while chatting, friendly cafe meetup scene, natural cross language communication, warm indoor lighting, modern lifestyle photography, clean aesthetic',
        imageSeq: 'st-scenario-2',
        imageSrc: '/images/mosstalk/standard/10-daily.jpg',
      },
      {
        icon: 'ri-book-open-line', name: '语言自学', desc: '外语阅读辅助、单词查询、发音学习，随身私人口语教练',
        imageQuery: 'Student using MossTalk ring translator device as personal language learning tool while studying foreign language textbook, smartphone showing translation app with vocabulary lookup feature, portable speaking coach gadget, modern study desk with notebook and books, bright natural daylight, clean minimal photography, academic atmosphere',
        imageSeq: 'st-scenario-3',
        imageSrc: '/images/mosstalk/standard/11-learning.jpg',
      },
      {
        icon: 'ri-shopping-bag-3-line', name: '海外购物', desc: '商品标签翻译、与店员沟通、退税咨询，海外剁手零障碍',
        imageQuery: 'Traveler using MossTalk ring translator to read product labels and communicate with shop assistant in foreign boutique, camera translation feature scanning price tag, overseas shopping scene with fashion retail interior, real time language assistance gadget, warm ambient commercial lighting, clean photography',
        imageSeq: 'st-scenario-4',
        imageSrc: '/images/mosstalk/standard/12-shopping.jpg',
      },
    ],
  },
  features: {
    title: '核心功能',
    items: [
      {
        icon: 'ri-file-text-line', name: '文本翻译', desc: '支持140+语种双向文本翻译，输入即译，准确流畅，支持复制与分享。',
        imageSrc: '/images/mosstalk/standard/3-text.jpg',
        imageQuery: 'MossTalk smartphone app screen showing clean text translation interface with Chinese input and English output side by side, 140 plus language bidirectional translation feature, modern minimalist app UI design, soft studio lighting, professional mobile app product photography',
        imageSeq: 'st-feature-1',
      },
      {
        icon: 'ri-mic-line', name: '语音翻译', desc: '一键录音实时翻译，语音输入秒级响应，支持连续对话模式。',
        imageSrc: '/images/mosstalk/standard/4-voice.jpg',
        imageQuery: 'Hand holding smartphone with MossTalk voice translation feature active, microphone recording interface with real time speech to text conversion, sound wave animation on screen, one tap voice input with instant translation output, modern mobile app design, clean studio photography',
        imageSeq: 'st-feature-2',
      },
      {
        icon: 'ri-camera-line', name: '拍照翻译', desc: '对准文字拍照即可识别翻译，支持竖排古文、手写体等多种复杂场景。',
        imageSrc: '/images/mosstalk/standard/5-photo.jpg',
        imageQuery: 'Smartphone camera using MossTalk OCR photo translation feature pointing at Chinese vertical text menu with English translation overlay on screen, optical character recognition instant translation, restaurant menu scanning scene, modern app AR translation interface, warm restaurant lighting, clean photography',
        imageSeq: 'st-feature-3',
      },
      {
        icon: 'ri-chat-1-line', name: '实时对话翻译', desc: '面对面交流时自动识别双方语种，分屏显示翻译内容，自然对话不间断。',
        imageSrc: '/images/mosstalk/standard/6-dialogue.jpg',
        imageQuery: 'MossTalk app conversation translation mode with split screen displaying Chinese on one side and English translation on other, automatic language detection for both speakers, real time bilingual dialogue interface, face to face communication concept, modern chat style UI design, clean photography',
        imageSeq: 'st-feature-4',
      },
      {
        icon: 'ri-headphone-line', name: '基础同传', desc: '支持同声传译模式，可搭配蓝牙耳机实现私密收听翻译内容。',
        imageSrc: '/images/mosstalk/standard/7-simultaneous.jpg',
        imageQuery: 'MossTalk ring translator device next to wireless Bluetooth earbuds, simultaneous interpretation mode with private listening via earphones, smartphone showing real time speech translation output, hands free translation listening concept, modern tech accessories on desk, clean product photography, soft lighting',
        imageSeq: 'st-feature-5',
      },
      {
        icon: 'ri-live-line', name: '通话双语字幕', desc: '音视频通话时自动生成双语字幕，跨国视频聊天、远程会议无障碍沟通。',
        imageSrc: '/images/mosstalk/standard/8-subtitle.jpg',
        imageQuery: 'MossTalk app video call interface with bilingual Chinese English subtitles overlay during international video chat, two people on screen communicating across languages with real time captions, AI powered call translation feature, modern communication concept, clean UI design, professional soft lighting',
        imageSeq: 'st-feature-6',
      },
    ],
  },
  advantages: {
    title: '产品亮点',
    subtitle: '小巧便携，功能强大，永久免费',
    items: [
      { icon: 'ri-global-line', name: '140+ 语种在线翻译', desc: '覆盖全球200+国家与地区主流语种，满足出境商旅全场景翻译需求' },
      { icon: 'ri-wifi-off-line', name: '10 种离线语种', desc: '无网络环境下仍可翻译10种常用语种，境外无信号也不慌' },
      { icon: 'ri-battery-charge-line', name: '超长待机', desc: '充电30分钟即可待机30天，一次充电多趟旅程无忧' },
      { icon: 'ri-smartphone-line', name: '手机支架设计', desc: '指环式卡扣设计，既是翻译机也是手机支架，看视频、视频通话两相宜' },
      { icon: 'ri-vip-crown-line', name: '永久免费基础版', desc: '文本翻译、语音翻译、对话翻译等核心功能永久免费，无需订阅' },
      { icon: 'ri-palette-line', name: '三色可选', desc: '曜石黑 / 玫瑰金 / 星耀银三款配色，搭配个人风格' },
    ],
  },
  specs: {
    title: '硬件规格参数',
    rows: [
      { label: '产品型号', value: 'MossTalk Pro T1 / XY-T02' },
      { label: '产品直径', value: '56.5 mm' },
      { label: '产品净重', value: '35 g' },
      { label: '电池容量', value: '60 mAh 锂聚合物电池' },
      { label: '充电时间', value: '约 30 分钟（充满）' },
      { label: '待机时间', value: '约 30 天' },
      { label: '连续翻译', value: '约 6 小时连续语音翻译' },
      { label: '蓝牙版本', value: 'Bluetooth 4.2 BLE' },
      { label: '适配系统', value: 'Android 8.0+、iOS 13+' },
      { label: '在线语种', value: '140+ 语种' },
      { label: '离线语种', value: '10 种（中/英/日/韩/法/德/西/俄/阿/葡）' },
      { label: '颜色选项', value: '曜石黑 / 玫瑰金 / 星耀银' },
    ],
  },
  related: {
    title: '相关产品推荐',
    items: [
      {
        name: 'MossTalk 商务款翻译机',
        desc: '标准款全功能 + AI会议总结 + 思维导图',
        href: '/mosstalk/business',
        imageQuery: 'MossTalk business edition premium translator device in titanium grey on executive desk, standard model upgraded with AI meeting summary and mind map features, clean product photography, warm office lighting',
        imageSeq: 'related-business',
      },
      {
        name: 'MossTalk 翻译耳机',
        desc: '100dB主动降噪，通话翻译一体',
        href: '/mosstalk/earbuds',
        imageQuery: 'MossTalk wireless translation earbuds with charging case, 100dB ANC noise cancelling translator earphones complementing ring translator, clean product photography, studio lighting',
        imageSeq: 'related-earbuds',
      },
    ],
  },
  cta: {
    primary: { text: '在线商务咨询', href: '#consultation' },
    secondary: { text: '下载产品白皮书', href: '/support/downloads' },
    tertiary: { text: '了解更多详情', href: 'https://www.newtranx.com/software/newtranx-mosstalk' },
    jd: { text: '京东购买', href: 'https://shop.m.jd.com/shop/transition?shopId=13063638&utm_source=pdappwakeupup_20170002' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsg8jtvf9bji89ovn0',
};

export const businessData = {
  banner: {
    title: 'MossTalk Pro 商务款翻译机',
    subtitle: '商务专属 AI 翻译 · 会议纪要 + 思维导图',
    tag: '商务版 · AI会议总结 · 群组聊天',
    imageQuery: 'MossTalk business edition premium ring translator device in titanium grey finish on modern executive desk, AI meeting summary and mind map generation features promoted, professional business translation gadget, sleek luxury design, clean product photography, warm ambient office lighting, corporate atmosphere',
    imageSeq: 'business-banner',
  },
  overview: {
    title: '产品概述',
    content: 'MossTalk Pro 商务款在标准款全部功能基础上，专为商务场景打造了五大专属功能：AI 会议总结（自动生成会议纪要 + 思维导图）、语音播报免查看（驾驶/行走时语音朗读翻译内容）、跨语言群组聊天（多人多语种实时群聊翻译）、大模型 AI 问答（商务资料智能检索问答）、耳机同传播报（蓝牙耳机私密收听同传）。适用于商务出差、跨境洽谈、外贸会议、企业外事对接等专业场景，是商务人士的随身翻译利器。',
    imageQuery: 'Business professional using MossTalk business edition translator during international negotiation meeting, AI meeting summary and mind map displaying on tablet after discussion, Chinese and foreign executives collaborating with real time translation, modern glass walled conference room, professional corporate photography, warm ambient lighting',
    imageSeq: 'business-overview',
  },
  scenarios: {
    title: '适用场景',
    items: [
      {
        icon: 'ri-flight-takeoff-line', name: '商务出差', desc: '海外出差全程随身翻译，从接机到谈判，AI总结自动整理每日会议纪要',
        imageQuery: 'Chinese business traveler at international airport using MossTalk business edition translator device, smartphone showing AI generated daily meeting summary from translation sessions, premium ring translator in titanium grey, professional business attire, modern airport terminal, clean corporate lifestyle photography, natural lighting',
        imageSeq: 'bu-scenario-1',
      },
      {
        icon: 'ri-team-line', name: '跨境洽谈', desc: '面对面商务谈判实时翻译，跨语言群组聊天支持多方同时沟通',
        imageQuery: 'International business negotiation scene with MossTalk business edition translator device on table between Chinese and Western executives, cross language group chat interface visible on tablet with multiple languages, face to face meeting with real time translation support, modern conference room, professional photography, warm ambient lighting',
        imageSeq: 'bu-scenario-2',
      },
      {
        icon: 'ri-building-line', name: '外贸会议', desc: '展会、产品推介会翻译支持，会议结束后一键生成思维导图总结',
        imageQuery: 'Trade show booth with exhibitor using MossTalk business edition translator to communicate with international clients, trade fair exhibition hall setting, AI mind map summary displayed on tablet after business discussion, professional commercial setting, clean photography, bright exhibition lighting',
        imageSeq: 'bu-scenario-3',
      },
      {
        icon: 'ri-government-line', name: '企业外事对接', desc: '政府部门、跨国企业外事接待，专业术语翻译准确，礼仪得体',
        imageQuery: 'Chinese government official receiving foreign delegation using MossTalk business edition translator for formal diplomatic meeting, professional interpretation device on meeting table, official reception in government building, formal diplomatic environment, clean photography, warm interior lighting',
        imageSeq: 'bu-scenario-4',
      },
    ],
  },
  features: {
    title: '核心功能',
    items: [
      {
        icon: 'ri-mind-map', name: 'AI 会议总结', desc: '自动生成会议纪要 + 思维导图，语音输入后一键导出结构化总结，关键决策不遗漏。',
        imageQuery: 'Tablet screen displaying MossTalk business edition AI generated structured meeting summary with mind map visualization and action items, automatic meeting minutes creation from voice input, one click export feature, modern productivity tool interface, clean design, soft professional lighting',
        imageSeq: 'bu-feature-1',
      },
      {
        icon: 'ri-volume-up-line', name: '语音播报免查看', desc: '驾驶、行走等不便看手机场景，语音自动朗读翻译内容，安全又高效。',
        imageQuery: 'Person driving car with smartphone mounted on dashboard, MossTalk business edition voice reading translation aloud through car speakers, hands free safe translation consumption while driving, modern car interior, daylight driving scene, clean photography, safe technology concept',
        imageSeq: 'bu-feature-2',
      },
      {
        icon: 'ri-group-line', name: '跨语言群组聊天', desc: '多人多语种实时群聊翻译，每人都用自己的语言发送，系统自动互译。',
        imageQuery: 'MossTalk business edition group chat interface showing multiple languages in single conversation thread, real time multilingual group translation with Chinese English Japanese Korean messages, diverse international team communication, modern messaging app design, clean UI, professional setting',
        imageSeq: 'bu-feature-3',
      },
      {
        icon: 'ri-brain-line', name: '大模型 AI 问答', desc: '接入大语言模型，支持商务资料智能检索、行业知识问答、专业术语解释。',
        imageQuery: 'MossTalk business edition AI chat interface with large language model query about business documents, intelligent business knowledge base assistant, professional terminology explanation feature, modern AI powered app design, clean UI, soft blue glow, professional setting',
        imageSeq: 'bu-feature-4',
      },
      {
        icon: 'ri-headphone-line', name: '耳机同传播报', desc: '蓝牙耳机私密收听同传翻译，商务场合不影响他人，信息保密得体。',
        imageQuery: 'Business executive wearing wireless Bluetooth earbud for private simultaneous interpretation listening via MossTalk business edition during meeting, discreet translation reception without disturbing others, professional conference setting with colleagues nearby, clean photography, soft lighting',
        imageSeq: 'bu-feature-5',
      },
      {
        icon: 'ri-star-line', name: '标准款全功能', desc: '继承标准款全部功能：文本/语音/拍照翻译、对话翻译、基础同传、通话字幕。',
        imageQuery: 'MossTalk business edition smartphone screen displaying grid of all translation features including text voice photo camera and conversation modes, complete translation toolkit overview, modern app interface, clean mobile design, professional product photography, soft lighting',
        imageSeq: 'bu-feature-6',
      },
    ],
  },
  advantages: {
    title: '商务专属优势',
    subtitle: '不止翻译，更是您的随身商务助手',
    items: [
      { icon: 'ri-timer-line', name: '会议效率倍增', desc: 'AI会议总结+思维导图，会后一键分享，省去人工整理纪要的时间，效率提升300%' },
      { icon: 'ri-shield-check-line', name: '信息安全保障', desc: '商务对话数据加密传输，支持本地暂存后上传，保护商业机密' },
      { icon: 'ri-global-line', name: '140+ 语种覆盖', desc: '覆盖全球主流商务语种，满足任何国际市场商务沟通需求' },
      { icon: 'ri-smartphone-line', name: '多端协同', desc: '翻译记录云端同步，手机、平板、电脑多端查看，随时随地回溯商务对话' },
    ],
  },
  specs: {
    title: '硬件规格参数',
    rows: [
      { label: '产品型号', value: 'MossTalk Pro B1 / XY-T02B' },
      { label: '产品直径', value: '56.5 mm' },
      { label: '产品净重', value: '38 g' },
      { label: '电池容量', value: '75 mAh 锂聚合物电池' },
      { label: '充电时间', value: '约 35 分钟（充满）' },
      { label: '待机时间', value: '约 35 天' },
      { label: '连续翻译', value: '约 8 小时连续语音翻译' },
      { label: '蓝牙版本', value: 'Bluetooth 5.0 BLE' },
      { label: '适配系统', value: 'Android 8.0+、iOS 13+' },
      { label: '在线语种', value: '140+ 语种' },
      { label: '离线语种', value: '15 种' },
      { label: '颜色', value: '钛金灰（商务专属色）' },
    ],
  },
  related: {
    title: '相关产品推荐',
    items: [
      {
        name: 'MossTalk 标准款翻译机',
        desc: '轻巧便携，三色可选，日常出行翻译利器',
        href: '/mosstalk/standard',
        imageQuery: 'MossTalk standard ring translator device in three colors, compact 35g travel translation gadget, clean product photography, studio lighting',
        imageSeq: 'related-standard',
      },
      {
        name: 'MossTalk 翻译耳机',
        desc: '100dB降噪，40h续航，通勤运动全能',
        href: '/mosstalk/earbuds',
        imageQuery: 'MossTalk wireless translation earbuds with open ear design and charging case, 100dB ANC and 40 hour battery life, clean product photography',
        imageSeq: 'related-earbuds',
      },
    ],
  },
  cta: {
    primary: { text: '在线商务咨询', href: '#consultation' },
    secondary: { text: '下载产品白皮书', href: '/support/downloads' },
    tertiary: { text: '联系采购', href: '/contact' },
    jd: { text: '京东购买', href: 'https://shop.m.jd.com/shop/transition?shopId=13063638&utm_source=pdappwakeupup_20170002' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsg8jtvf9bji89ovn0',
};

export const earbudsData = {
  banner: {
    title: 'MossTalk 翻译耳机',
    subtitle: '降噪 · 通话 · 翻译 · 音乐 · 运动 五合一',
    tag: '100dB ANC · 140+ 语种 · 40h 续航',
    imageQuery: 'MossTalk wireless translation earbuds with open ear design and charging case, five in one ANC noise cancelling calling translation music sports earphones, 100dB active noise cancellation 140 plus languages 40 hour battery life, premium wearable tech, clean white product photography on light gradient background, soft studio lighting',
    imageSeq: 'earbuds-banner',
  },
  overview: {
    title: '产品概述',
    content: 'MossTalk 翻译耳机是新译科技推出的集降噪、通话、翻译、音乐、运动五大功能于一体的智能翻译耳机。搭载 100dB 深度主动降噪技术，支持 140+ 语种毫秒级实时翻译，采用开放式佩戴设计全天舒适不压迫。40 小时超长续航，IPX5 防水等级，满足商务通勤、跨境电话、运动出行、外语听力学习等全场景需求。蓝牙 5.3 连接稳定低延迟，搭配 MossTalk APP 实现一键开启翻译模式。',
    imageQuery: 'Business professional wearing MossTalk open ear wireless translation earbuds during city commute, modern urban background with smartphone showing translation app interface, 100dB ANC noise cancelling translator earphones for cross language calls, lifestyle product photography, natural outdoor lighting, clean minimalist aesthetic',
    imageSeq: 'earbuds-overview',
  },
  scenarios: {
    title: '适用场景',
    items: [
      {
        icon: 'ri-train-line', name: '商务通勤', desc: '地铁/公交/驾车通勤途中，降噪听音乐+实时翻译，碎片时间高效利用',
        imageQuery: 'Professional commuter wearing MossTalk translation earbuds on modern subway train, noise cancelling mode active for listening to music while AI translation runs in background, urban commute lifestyle scene, city skyline through train window, business casual attire, clean photography, soft natural lighting',
        imageSeq: 'eb-scenario-1',
      },
      {
        icon: 'ri-phone-line', name: '跨境电话', desc: '跨国电话会议/视频通话，实时双语字幕翻译，沟通效率翻倍',
        imageQuery: 'Business person on international conference call wearing MossTalk translation earbuds, laptop screen showing video call with bilingual Chinese English subtitles, real time call translation feature, modern office setting, professional corporate photography, warm indoor lighting',
        imageSeq: 'eb-scenario-2',
      },
      {
        icon: 'ri-run-line', name: '运动出行', desc: 'IPX5防水，开放式佩戴安全感知环境，跑步骑行也能畅享翻译',
        imageQuery: 'Runner wearing MossTalk open ear translation earbuds outdoors in park, IPX5 waterproof sweat resistant design for sports, open ear wearing maintaining environmental awareness while translating, active fitness lifestyle concept, natural daylight, clean photography, dynamic outdoor scene',
        imageSeq: 'eb-scenario-3',
      },
      {
        icon: 'ri-headphone-line', name: '外语听力学习', desc: '外语播客/新闻/影视实时字幕翻译，沉浸式语言学习最佳伴侣',
        imageQuery: 'Student wearing MossTalk translation earbuds while studying foreign language on tablet, real time translation of English podcast to Chinese subtitles displayed on screen, immersive language learning with AI translation assistance, modern study environment with books and laptop, clean photography, bright natural lighting',
        imageSeq: 'eb-scenario-4',
      },
    ],
  },
  features: {
    title: '核心功能',
    items: [
      {
        icon: 'ri-volume-up-line', name: '100dB 深度降噪', desc: '自适应ANC降噪技术，根据环境噪音自动调节降噪深度，通话更清晰。',
        imageQuery: 'MossTalk translation earbuds closeup with sound wave cancellation visualization, 100dB ANC active noise cancelling technology diagram, adaptive ambient noise reduction, premium audio hardware detail, clean product photography, modern acoustic design, soft lighting',
        imageSeq: 'eb-feature-1',
      },
      {
        icon: 'ri-translate', name: '毫秒级实时翻译', desc: '140+语种互译，语音输入到翻译输出延迟低于200ms，对话自然流畅。',
        imageQuery: 'MossTalk earbuds connected to smartphone showing lightning fast real time translation from speech to text in under 200ms, 140 plus language pairs available, millisecond latency visualization, fast AI translation processing concept, modern tech interface, clean design, soft blue glow',
        imageSeq: 'eb-feature-2',
      },
      {
        icon: 'ri-phone-line', name: '高清通话', desc: '双麦克风ENC通话降噪，嘈杂环境下对方仍能清晰听到你的声音。',
        imageQuery: 'Person wearing MossTalk translation earbuds making phone call in busy noisy urban street, dual microphone ENC environmental noise cancellation ensuring crystal clear voice transmission, crowded city background, modern communication technology, clean photography, natural outdoor lighting',
        imageSeq: 'eb-feature-3',
      },
      {
        icon: 'ri-music-line', name: 'Hi-Fi 音质', desc: '12mm大动圈单元，支持AAC/SBC编解码，音乐模式享受高品质听觉体验。',
        imageQuery: 'MossTalk translation earbuds with musical notes visualization emerging from speaker, 12mm large dynamic driver unit for Hi-Fi audio quality, AAC SBC codec support, music listening mode concept, premium sound quality representation, clean product photography, modern acoustic design, soft studio lighting',
        imageSeq: 'eb-feature-4',
      },
      {
        icon: 'ri-run-line', name: '运动模式', desc: 'IPX5防水防汗，开放式设计保持环境感知，运动时安全与功能兼顾。',
        imageQuery: 'MossTalk open ear earbuds with water droplets demonstrating IPX5 waterproof rating, sports and sweat resistant design, open ear wearing style maintaining environmental awareness during outdoor exercise, active lifestyle product concept, clean product photography, dynamic lighting',
        imageSeq: 'eb-feature-5',
      },
      {
        icon: 'ri-battery-charge-line', name: '40h 超长续航', desc: '单次充电续航8小时，充电仓补充4次，总共40小时，一周一充即可。',
        imageQuery: 'MossTalk translation earbuds charging case with battery percentage indicator showing full charge, 40 hour total battery life concept with 8 hour single charge plus 4 case recharges, long lasting power for week long use, modern tech accessory, clean product photography, soft lighting',
        imageSeq: 'eb-feature-6',
      },
    ],
  },
  advantages: {
    title: '产品亮点',
    subtitle: '五合一全能翻译耳机，一副满足所有日常需求',
    items: [
      { icon: 'ri-headphone-line', name: '开放式舒适佩戴', desc: '不入耳开放式设计，全天佩戴无压迫感，同时保持环境感知，通勤更安全' },
      { icon: 'ri-battery-charge-line', name: '40小时超长续航', desc: '单次8h+充电仓32h，一周一充告别电量焦虑，长途飞行全程陪伴' },
      { icon: 'ri-water-flash-line', name: 'IPX5 防水', desc: '防汗防雨防水溅，运动出汗、户外小雨都能正常使用，耐用可靠' },
      { icon: 'ri-bluetooth-line', name: '蓝牙 5.3', desc: '最新蓝牙5.3协议，连接更快更稳，延迟低至50ms，音画同步零感知' },
    ],
  },
  specs: {
    title: '硬件规格参数',
    rows: [
      { label: '产品型号', value: 'MossTalk E1 / XY-TE01' },
      { label: '降噪类型', value: '自适应 ANC 主动降噪' },
      { label: '降噪深度', value: '100 dB' },
      { label: '驱动单元', value: '12 mm 大动圈' },
      { label: '音频编解码', value: 'AAC / SBC' },
      { label: '蓝牙版本', value: 'Bluetooth 5.3' },
      { label: '佩戴方式', value: '开放式不入耳' },
      { label: '单次续航', value: '约 8 小时' },
      { label: '总续航（含充电仓）', value: '约 40 小时' },
      { label: '充电接口', value: 'Type-C（充电仓）' },
      { label: '防水等级', value: 'IPX5（防汗防雨）' },
      { label: '单耳重量', value: '约 8.5 g' },
      { label: '充电仓重量', value: '约 55 g' },
      { label: '翻译语种', value: '140+ 语种在线翻译' },
      { label: '适配系统', value: 'Android 8.0+、iOS 13+' },
    ],
  },
  related: {
    title: '相关产品推荐',
    items: [
      {
        name: 'MossTalk 标准款翻译机',
        desc: '35g超轻指环翻译机，日常出行翻译利器',
        href: '/mosstalk/standard',
        imageQuery: 'MossTalk standard ring translator device in three colors, 35g compact travel translation gadget pairing with earbuds, clean product photography',
        imageSeq: 'related-standard',
      },
      {
        name: 'MossTalk 商务款翻译机',
        desc: 'AI会议总结+思维导图，商务专属翻译',
        href: '/mosstalk/business',
        imageQuery: 'MossTalk business edition premium translator in titanium grey, AI meeting summary and mind map features, complement to translation earbuds, clean product photography',
        imageSeq: 'related-business',
      },
    ],
  },
  cta: {
    primary: { text: '在线商务咨询', href: '#consultation' },
    secondary: { text: '下载产品白皮书', href: '/support/downloads' },
    tertiary: { text: '联系采购', href: '/contact' },
    jd: { text: '京东购买', href: 'https://shop.m.jd.com/shop/transition?shopId=13063638&utm_source=pdappwakeupup_20170002' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsg8jtvf9bji89ovn0',
};